import { render } from "./erroriModal.vue?vue&type=template&id=b7765ca4&ts=true"
import script from "./erroriModal.vue?vue&type=script&lang=ts"
export * from "./erroriModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__